const resolveClientId = () => {
  let id = window.ini.DEFAULT_CLIENT_ID ?? "2";
  const hostname = window.location.hostname?.toLowerCase?.();

  if (window.ini.CLIENTS) {
    id = window.ini.CLIENTS[hostname] ?? id;
  }

  return id;
};

let clientId = resolveClientId();

const setClientId = (id) => {
  clientId = id;
};

export { clientId, setClientId, resolveClientId };
